/* */
import React, { useState, useCallback, Fragment } from 'react';
import { Alert, Col } from 'reactstrap';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import actions from 'redux/actions';
import { toggleDialog } from 'helpers';

import PaymentMethod from 'components/PaymentMethod';
import Loading from 'components/Loading';
import ErrorMessage from 'components/ErrorMessage';

import SubmitDeleteCard from './Dialog/SubmitDeleteCard';
import { useTranslation } from 'react-i18next';
import { CommonIcons } from 'components/Icons';
import NewDesign from 'components/NewDesign';

const { setDefaultCard } = actions;

const ListMethod = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const paymentReducer = useSelector((state) => state.paymentReducer, shallowEqual);
  const [card, setCard] = useState({});
  const [openSubmitDeleteCard, setOpenSubmitDeleteCard] = useState(false);
  const [closingSubmitDeleteCard, setClosingSubmitDeleteCard] = useState(false);
  const {
    isFetchedListCard,
    isFetchingListCard,
    listCard,
    isSettingDefault,
    errorFetchListCard,
    paymentSelected,
    queueIdRequestingDefault,
  } = paymentReducer;

  // Function
  const toggleSubmitDeleteCard = useCallback(() => {
    toggleDialog(
      openSubmitDeleteCard,
      setOpenSubmitDeleteCard,
      closingSubmitDeleteCard,
      setClosingSubmitDeleteCard
    );
  }, [openSubmitDeleteCard, closingSubmitDeleteCard, listCard, paymentSelected]);

  const onSetDefault = useCallback((id) => {
    return (e) => {
      e.stopPropagation();
      dispatch(setDefaultCard({ cardId: id }));
    };
  }, []);

  const onRemove = (id, last4) => {
    return (e) => {
      e.stopPropagation();
      setCard({ id, last4 });
      toggleSubmitDeleteCard();
    };
  };

  // Render
  const render = useCallback(() => {
    if (isFetchingListCard) return <Loading />;
    if (errorFetchListCard) return <ErrorMessage />;
    if (isFetchedListCard) {
      if (listCard.length === 0) return "You don't have any payment method!";
      return (
        <Fragment>
          <div className='payment-method__list d-grid gap-14px grid-3-cols mobile:grid-1-cols'>
            {listCard.map((p) => (
              <PaymentMethod
                key={p.id}
                pack={p}
                isDefault={p.id === paymentSelected.id}
                onSetDefault={onSetDefault}
                onRemove={onRemove}
                isActive={p.id === paymentSelected.id}
                isSettingDefault={isSettingDefault}
                packageIsSetting={queueIdRequestingDefault.includes(p.id)}
              />
            ))}
          </div>
        </Fragment>
      );
    }
    return;
  }, [
    isFetchedListCard,
    isFetchingListCard,
    errorFetchListCard,
    listCard,
    isSettingDefault,
    paymentSelected,
    openSubmitDeleteCard,
    closingSubmitDeleteCard,
  ]);

  return (
    <Col xs='12' md='12' className='checkout-form__list-method'>
      {(openSubmitDeleteCard || closingSubmitDeleteCard) && (
        <SubmitDeleteCard
          isOpen={openSubmitDeleteCard}
          toggle={toggleSubmitDeleteCard}
          card={card}
        />
      )}
      <NewDesign.Typography component='h4' className='mb-2'>
        Payment Methods
      </NewDesign.Typography>
      <div className='mb-2' style={{ paddingTop: '0.5rem' }}>
        {render()}
      </div>

      <Alert color='primary'>
        <p style={{ display: 'flex', alignItems: 'center' }}>
          <CommonIcons.Tooltip size={20} className='mr-2' />
          {t('notice:additional_fee_platform_service')}
        </p>
      </Alert>
    </Col>
  );
};

export default React.memo(ListMethod);
